export enum SnackbarDisplayTypes {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error'
}
